import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { useId } from 'js/hooks/useId';
import { ANSWER_DRAG_TYPE } from './grouping-utils';
import styles from './Grouping.module.scss';

const TOOLTIP_DELAY = { show: 700, hide: 100 };

export default function GroupingAnswerChip({
  answer,
  draggable: isDraggable = false,
}) {
  const ref = useRef(null);
  const [dragging, setDragging] = useState(false);
  const targetId = useId();
  const label = answer?.text || String(answer?.value ?? '');

  useEffect(() => {
    const el = ref.current;
    if (!el || !isDraggable) {
      return undefined;
    }

    return draggable({
      element: el,
      getInitialData: () => ({
        type: ANSWER_DRAG_TYPE,
        value: String(answer.value),
        answer,
      }),
      onDragStart: () => setDragging(true),
      onDrop: () => setDragging(false),
    });
  }, [answer, isDraggable]);

  return (
    <li
      ref={ref}
      id={targetId}
      className={classNames(styles.chip, {
        [styles.chipDraggable]: isDraggable,
        [styles.chipDragging]: dragging,
      })}
    >
      <p
        className={classNames(styles.chipText, 'line-clamp-var')}
        style={{ '--line-clamp': 4 }}
      >
        {label}
      </p>
      {!dragging && label ? (
        <UncontrolledTooltip target={targetId} delay={TOOLTIP_DELAY} autohide>
          {label}
        </UncontrolledTooltip>
      ) : null}
    </li>
  );
}
